import styled, { css } from 'styled-components'

const designerCSS = css`
   {
    height: calc(100% + 15px);
    height: 100%;
    transition: width 300ms ease-in-out;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 0 0 0 0;
    overflow: hidden;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  section .bid_amount_field {
    margin: 0 0 5px 0;
    display: flex;
    flex-direction: column;
  }
  section .bid_amount_field input[type='text'] {
    width: 100%;
    background: hsl(218, 23%, 25%);
    background: hsla(0, 0%, 100%, 0.2);
    -webkit-box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.3);
    box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    font-size: 1.2rem;
    font-weight: 600;
    text-align: center;
    padding: 6px;
    position: relative;
    z-index: 1;
    border: 2px solid hsla(221, 73%, 47%, 0.8);
    letter-spacing: -0.01em;
  }
  .row.multiplier_slider {
    padding-top: 10px;
    padding-bottom: 0;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
  }
  section .row.multiplier_amount_field {
    position: relative;
    width: 100%;
    margin: 15px 0 0 0;
  }
  .multiplier_amount_field .multiply {
    position: absolute;
    top: calc(50% + 1px);
    transform: translateY(-50%);
    left: 40px;
    content: '';
    display: block;
    font-weight: 700;
    font-size: 0.9rem;
    line-height: 100%;
  }
  .multiplier_amount_field output {
    background: hsl(218, 23%, 25%);
    background: hsla(0, 0%, 100%, 0.1);
    -webkit-box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.3);
    box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.3);
    padding: 10px 16px;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 400;
    width: 60%;
    text-align: center;
    justify-content: center;
  }
  .multiplier_amount_field.busted output {
    width: 100%;
  }
  button {
    width: 100%;
    text-align: center;
    font-size: 0.8rem;
    text-transform: uppercase;
    padding: 15px 0;
    line-height: 100%;
    font-weight: 500;
  }

  section .bidding_buttons.busted button.login {
    margin: 10px 0 0 0;
  }
  section .bidding_buttons.busted button.login strong {
    font-weight: 600;
  }

  section .bidding_buttons.busted button.timer {
    display: flex;
    justify-content: space-between;
    margin: 10px 0 0 0;
  }
  section .bidding_buttons.busted button.timer strong {
    font-weight: 600;
  }
  section .bidding_buttons.busted button.timer span {
    text-transform: none;
    font-weight: 600;
  }

  section .bidding_buttons.busted button.cashout {
    background: linear-gradient(180deg, #153a1b, #14381a, #143719, #133518, #133318, #123117, #123016, #112e15);
    border: 1px solid hsla(126, 100%, 28%, 0.3);
    text-transform: uppercase;
    font-weight: 600;
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 10px 0 0 0;
  }
  section .bidding_buttons.busted button.cashout .pandl_ind {
  }
  section .bidding_buttons.busted button.cashout .pandl_ind span {
    color: hsla(126, 100%, 38%, 1);
    font-weight: 600;
  }
  section .bidding_buttons.busted button.cashout .pandl_ind span.divider {
    opacity: 0.5;
    padding: 0 5px;
  }

  .togCheck:checked + .togContent .busted {
    padding: 0;
  }
  section.place_bid_button_wrapper {
    position: relative;
    border-bottom: 0;
  }
  section .bidding_buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 0 0 15px 0;
  }
  section .bidding_buttons button {
    width: 100%;
    border-radius: 10px;
    text-transform: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    line-height: 100%;
    font-size: 0.8rem;
    font-weight: 600;
    z-index: 2;
    position: relative;
    margin: 50px 0 0 0;
  }
  section .bidding_buttons.busted {
    margin: 0;
  }
  section .bidding_buttons.busted button {
    margin: 0;
  }
  section .bidding_buttons button {
    justify-content: center;
    text-transform: uppercase;
  }
  section .bidding_buttons button:before {
    display: block;
    height: 14px;
    width: 14px;
    border: inherit;
    position: absolute;
    left: calc(50% - 7px);
    clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
    border-radius: 0 0 0 0.35em;
    content: '';
    z-index: 0;
    border: 0;
  }
  section .bidding_buttons button:hover {
    filter: brightness(110%);
    box-shadow: 0 0 35px 0px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 0 35px 0px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0 0 35px 0px rgba(0, 0, 0, 0.2);
    z-index: 9;
  }
  section .bidding_buttons button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  @media (max-width: 1600px) {
    section .bidding_buttons button {
      margin: 70px 0 0 0;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/panels.css */
  /* {
    position: relative;
    z-index: 0;
    height: auto;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    transition: all 1s;
  } */
  section {
    display: flex;
    flex-wrap: wrap;
    flex-flow: column;
    width: 100%;
    padding: 15px 0;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  }
  section:last-child {
    border-bottom: 0;
  }
  section .row {
    flex-flow: row;
    justify-content: space-between;
    margin: 0;
    padding: 0 15px;
    display: flex;
    align-items: center;
  }
  section .row.subtitle {
    font-weight: 600;
    font-size: 0.75rem;
    margin: 0 0 8px 0;
    text-transform: uppercase;
  }
  section .subtitle {
    font-weight: 600;
    font-size: 0.75rem;
    white-space: nowrap;
    text-transform: uppercase;
    display: flex;
    align-items: center;
  }
  .togCheck:checked + .togContent {
    visibility: visible;
    height: 100%;
    width: 100%;
    opacity: 1;
  }
  .togCheck + .togContent {
    visibility: hidden;
    height: 0;
    width: 0;
    opacity: 0;
  }
`

const developerCSS = css``

export const BustedCardCSS = styled.div`
  width: 100%;
  ${designerCSS}
  ${developerCSS}
`
